// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file inventory/v1/signal_backoffice.proto (package inventory.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { AlertStatus, WinningRule } from "./alert_pb";
import { file_inventory_v1_alert } from "./alert_pb";
import type { RiskLevel, RiskSeverityScore, RiskType } from "./risk_pb";
import { file_inventory_v1_risk } from "./risk_pb";
import type { Signal } from "./signal_pb";
import { file_inventory_v1_signal } from "./signal_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file inventory/v1/signal_backoffice.proto.
 */
export const file_inventory_v1_signal_backoffice: GenFile = /*@__PURE__*/
  fileDesc("CiRpbnZlbnRvcnkvdjEvc2lnbmFsX2JhY2tvZmZpY2UucHJvdG8SDGludmVudG9yeS52MSK6AgoMUmlza01ldGFkYXRhEhcKD3Jpc2tfaW5zaWdodF9pZBgBIAEoCRIpCghzZXZlcml0eRgCIAEoDjIXLmludmVudG9yeS52MS5SaXNrTGV2ZWwSJAoEdHlwZRgDIAEoDjIWLmludmVudG9yeS52MS5SaXNrVHlwZRI8Cg5zZXZlcml0eV9zY29yZRgEIAEoCzIfLmludmVudG9yeS52MS5SaXNrU2V2ZXJpdHlTY29yZUgAiAEBEj0KCmRlYnVnX2luZm8YBSADKAsyKS5pbnZlbnRvcnkudjEuUmlza01ldGFkYXRhLkRlYnVnSW5mb0VudHJ5GjAKDkRlYnVnSW5mb0VudHJ5EgsKA2tleRgBIAEoCRINCgV2YWx1ZRgCIAEoCToCOAFCEQoPX3NldmVyaXR5X3Njb3JlItoCChBCYWNrb2ZmaWNlU2lnbmFsEiQKBnNpZ25hbBgBIAEoCzIULmludmVudG9yeS52MS5TaWduYWwSLgoLd29ya19zdGF0dXMYAiABKA4yGS5pbnZlbnRvcnkudjEuQWxlcnRTdGF0dXMSKQoIc2V2ZXJpdHkYAyABKA4yFy5pbnZlbnRvcnkudjEuUmlza0xldmVsEhAKCGlzX2FsZXJ0GAQgASgIEi8KDHdpbm5pbmdfcnVsZRgFIAEoCzIZLmludmVudG9yeS52MS5XaW5uaW5nUnVsZRIaChJieXBhc3NfYWxlcnRfcnVsZXMYBiABKAgSLQoEcmlzaxgIIAEoCzIaLmludmVudG9yeS52MS5SaXNrTWV0YWRhdGFIAIgBARIuCgp1cGRhdGVkX2F0GAkgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcEIHCgVfcmlza0K9AQoQY29tLmludmVudG9yeS52MUIVU2lnbmFsQmFja29mZmljZVByb3RvUAFaQWdpdGh1Yi5jb20vbGVtYS5haS9sZW1tYXRhL2FwaS9wcm90by9nZW4vaW52ZW50b3J5L3YxO2ludmVudG9yeXYxogIDSVhYqgIMSW52ZW50b3J5LlYxygIMSW52ZW50b3J5XFYx4gIYSW52ZW50b3J5XFYxXEdQQk1ldGFkYXRh6gINSW52ZW50b3J5OjpWMWIGcHJvdG8z", [file_google_protobuf_timestamp, file_inventory_v1_alert, file_inventory_v1_risk, file_inventory_v1_signal]);

/**
 * RiskMetadata is what only the risk row holds; the signal holds the rest of the risk.
 *
 * @generated from message inventory.v1.RiskMetadata
 */
export type RiskMetadata = Message<"inventory.v1.RiskMetadata"> & {
  /**
   * @generated from field: string risk_insight_id = 1;
   */
  riskInsightId: string;

  /**
   * @generated from field: inventory.v1.RiskLevel severity = 2;
   */
  severity: RiskLevel;

  /**
   * @generated from field: inventory.v1.RiskType type = 3;
   */
  type: RiskType;

  /**
   * @generated from field: optional inventory.v1.RiskSeverityScore severity_score = 4;
   */
  severityScore?: RiskSeverityScore;

  /**
   * @generated from field: map<string, string> debug_info = 5;
   */
  debugInfo: { [key: string]: string };
};

/**
 * Describes the message inventory.v1.RiskMetadata.
 * Use `create(RiskMetadataSchema)` to create a new message.
 */
export const RiskMetadataSchema: GenMessage<RiskMetadata> = /*@__PURE__*/
  messageDesc(file_inventory_v1_signal_backoffice, 0);

/**
 * BackofficeSignal is a signal as support sees it: the signal itself, the state the customer
 * Signal message leaves to Alert, and its risk metadata. Support-only.
 *
 * @generated from message inventory.v1.BackofficeSignal
 */
export type BackofficeSignal = Message<"inventory.v1.BackofficeSignal"> & {
  /**
   * @generated from field: inventory.v1.Signal signal = 1;
   */
  signal?: Signal;

  /**
   * @generated from field: inventory.v1.AlertStatus work_status = 2;
   */
  workStatus: AlertStatus;

  /**
   * OrgSignal.GetSeverity: manual ?? rule engine ?? intrinsic.
   *
   * @generated from field: inventory.v1.RiskLevel severity = 3;
   */
  severity: RiskLevel;

  /**
   * @generated from field: bool is_alert = 4;
   */
  isAlert: boolean;

  /**
   * Unset for a bypass alert and for a signal that is not an alert.
   *
   * @generated from field: inventory.v1.WinningRule winning_rule = 5;
   */
  winningRule?: WinningRule;

  /**
   * @generated from field: bool bypass_alert_rules = 6;
   */
  bypassAlertRules: boolean;

  /**
   * Set only for a signal linked to a risk.
   *
   * @generated from field: optional inventory.v1.RiskMetadata risk = 8;
   */
  risk?: RiskMetadata;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 9;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message inventory.v1.BackofficeSignal.
 * Use `create(BackofficeSignalSchema)` to create a new message.
 */
export const BackofficeSignalSchema: GenMessage<BackofficeSignal> = /*@__PURE__*/
  messageDesc(file_inventory_v1_signal_backoffice, 1);

